export default {
    computed: {
        passwordStrength() {
            const p = this.passwordToCheck || "";

            const validations = {
                minLength: p.length >= 12,
                uppercase: /[A-Z]/.test(p),
                lowercase: /[a-z]/.test(p),
                number: /\d/.test(p),
                specialChar: /[!@#$%^&*?_~\-()]/.test(p)
            };

            const score = Object.values(validations).filter(Boolean).length;
            const labels = [
                "Very Weak",
                "Weak",
                "Better",
                "Medium",
                "Strong",
                "Strongest"
            ];
            const colors = [
                "text-danger",
                "text-danger",
                "text-warning",
                "text-warning",
                "text-success",
                "text-success"
            ];

            return {
                description:
                    p.length === 0 ? "Password not entered" : labels[score],
                color: p.length === 0 ? "text-muted" : colors[score],
                class_name: "strength" + score,
                validations
            };
        }
    }
};
